<div
  id="full-width-modal-modalNewConversationTitle"
  class="modal fade show"
  tabindex="-1"
  aria-labelledby="modalNewConversationTitle"
  style="display: block"
  aria-modal="true"
  role="dialog"
  #modalContainer
>
  <div
    class="modal-dialog modal-dialog-scrollable modal-full-width"
    style="max-height: 90vh"
  >
    <div class="modal-content">
      <div
        class="modal-header"
        [ngClass]="{ 'bg-danger bg-opacity-25': data.priority === 'CRITICAL' }"
      >
        <h3 class="modal-title me-2" id="modalAddEditContactTitle">
          {{ data?.name }}
        </h3>
        <!--
          Temperature is derived from qualification and health (E2 RF-22, RF-23): shown
          read-only next to the priority, explained on hover, never offered for editing.
        -->
        <span
          class="badge bg-soft-secondary text-secondary px-2 font-13 me-2"
          [matTooltip]="'kanban.cardDetails.temperatureTooltip' | translate"
        >
          @if (data?.temperature === CardTemperatureEnum.HOT) {
            <i class="ri-fire-fill text-danger me-1"></i>
          } @else if (data?.temperature === CardTemperatureEnum.WARM) {
            <i class="ri-sun-cloudy-fill me-1"></i>
          } @else if (data?.temperature === CardTemperatureEnum.COLD) {
            <i class="ri-snowy-line text-info me-1"></i>
          }
          {{ temperatureLabel | translate }}
        </span>
        <div class="dropdown">
          <span
            class="badge dropdown-toggle px-2 font-14 fw-bold"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            [ngClass]="{
              'bg-danger text-white':
                data?.priority === 'URGENT' || data?.priority === 'CRITICAL',
              'bg-warning text-dark': data?.priority === 'HIGH',
              'bg-info text-white': data?.priority === 'MEDIUM',
              'bg-success text-white': data?.priority === 'LOW',
              'bg-secondary text-white': data?.priority === 'NO PRIORITY',
            }"
          >
            {{ translateEnuns(data.priority) | translate }}
          </span>

          <ul class="dropdown-menu dropdown-menu-end">
            @for (p of priorities; track p.value) {
              <li>
                <a
                  class="dropdown-item"
                  href="javascript:void(0);"
                  (click)="updatePriority(p.value)"
                >
                  <span class="badge me-2" [ngClass]="p.badgeClass">●</span>
                  {{ p.label | translate }}
                </a>
              </li>
            }
          </ul>
        </div>
        <span
          class="badge px-2 font-14 fw-bold ms-2"
          [ngStyle]="{
            'background-color': data.stage.bgColor,
            color: (data.stage.bgColor | readableText),
          }"
        >
          {{ data.stage.name }}
        </span>
        @if (data.isPrivate) {
          <span
            [matTooltip]="
              'kanban.cardDetails.privateOpportunityTooltip' | translate
            "
            class="ms-2 z-100 d-inline-flex align-items-center"
          >
            <i class="mdi mdi-lock-outline text-danger fs-4 lh-1"></i>
          </span>
        }
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="close()"
        ></button>
      </div>

      <div
        class="modal-body d-flex gap-3 overflow-hidden p-0"
        style="max-height: calc(90vh - 80px)"
      >
        <div
          class="col-2 border-end p-3 my-2 scroll d-flex flex-column justify-content-between"
        >
          @if (data.customer) {
            <div class="simplebar-content">
              <div class="text-center pb-3 border-bottom mb-3">
                <img
                  [src]="getContactImage($safeNavigationMigration(data?.customer?.contact))"
                  (error)="onImageError($event)"
                  [alt]="'kanban.cardDetails.contactImageAlt' | translate"
                  class="rounded-circle border mb-2"
                  width="64"
                  height="64"
                  style="object-fit: cover"
                />
                <div class="fw-bold font-18">
                  {{ data?.customer?.name }}
                </div>
                <!--
                  Reads `leadOrigin`, denormalised on the deal (RF-08). It used to
                  read `leadSource.name`, which arrived from the board payload
                  through a `customer -> contact -> lead-source` lookup chain that
                  ran once per page of every stage column. That chain is gone
                  (RNF-01, RNF-02), so this block would otherwise render blank.
                -->
                @if (data?.leadOrigin?.sourceName || data?.leadOrigin?.type) {
                  <small
                    class="badge bg-secondary bg-opacity-25 text-dark"
                    [matTooltip]="
                      'kanban.cardDetails.contactSourceTooltip' | translate
                    "
                  >
                    <i class="ri-map-pin-2-line me-1" style="width: 14px"></i>
                    {{
                      data?.leadOrigin?.sourceName ||
                        ("kanban.leadOriginType." + $safeNavigationMigration(data?.leadOrigin?.type)
                          | translate)
                    }}
                  </small>
                }

                <!--
                  Daily-radar signals on the deal detail
                  (SPEC-2026-08-crm-pipeline-deals-radar).

                  The same component the board card renders, reused rather than
                  duplicated: the label maps, the accessibility treatment and the
                  unavailable state are defined once. The detail is where the
                  salesperson acts on the deal, so the signals that made them open it
                  have to be here too.
                -->
                @if (getModuleCRM()) {
                  <div class="mt-3 text-start">
                    <app-card-radar
                      [card]="data"
                      (scheduleNextAction)="openNextActionDialog()"
                      (openScoreExplanation)="openScoreExplanation()"
                    ></app-card-radar>
                  </div>
                }
                @if (getModuleCRM() && !isClosedDeal) {
                  <div class="mt-3 text-start">
                    <small
                      class="text-uppercase text-muted fw-semibold font-11"
                    >
                      {{ "kanban.cardDetails.qualificationTitle" | translate }}
                    </small>
                    <div class="btn-group btn-group-sm w-100 mt-1" role="group">
                      @for (level of qualificationLevels; track level) {
                        <button
                          type="button"
                          class="btn"
                          [ngClass]="
                            qualificationDecided === level
                              ? 'btn-primary'
                              : 'btn-outline-secondary'
                          "
                          [disabled]="savingQualification"
                          (click)="setQualification(level)"
                        >
                          {{ QUALIFICATION_LABEL[level] | translate }}
                        </button>
                      }
                    </div>
                    <small class="text-muted d-block mt-1 font-11">
                      @if (qualificationDecided) {
                        {{
                          "kanban.cardDetails.qualificationDecided" | translate
                        }}
                        ·
                        <a
                          href="javascript:void(0);"
                          (click)="setQualification(null)"
                        >
                          {{
                            "kanban.cardDetails.qualificationClear" | translate
                          }}
                        </a>
                      } @else if (data?.leadQuality?.qualification) {
                        {{
                          "kanban.cardDetails.qualificationRecommended"
                            | translate
                              : {
                                  level:
                                    (QUALIFICATION_LABEL[
                                      data.leadQuality.qualification
                                    ] | translate),
                                }
                        }}
                      }
                    </small>
                    <small
                      class="text-uppercase text-muted fw-semibold font-11 d-block mt-3"
                    >
                      {{ "kanban.bant.title" | translate }} · {{ bantDone }}/4
                    </small>
                    @for (fact of bantFacts; track fact) {
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          [id]="'bant-' + fact"
                          [checked]="data?.bant?.[fact] === true"
                          [disabled]="savingBant"
                          (change)="toggleBant(fact)"
                        />
                        <label
                          class="form-check-label font-13"
                          [for]="'bant-' + fact"
                        >
                          {{ BANT_FACT_LABEL[fact] | translate }}
                        </label>
                      </div>
                    }
                    <small class="text-muted font-11">{{
                      "kanban.bant.hint" | translate
                    }}</small>
                  </div>
                }

                <!--
                  Labeled pills, stacked and full width (owner decision 2026-08-20).
                  Icon-only circles centred in the column read as orphaned here: every
                  other thing in this sidebar — the CONTACT label, the phone, the tags —
                  is aligned left, and in a column this narrow an action is not
                  self-evident from a glyph alone.

                  The labels were already keyed in all four catalogs
                  (`kanban.cardDetails.goToAttendance` / `.startAttendance`) and unused:
                  the buttons carried them as hardcoded pt-BR tooltips instead. With the
                  word on the button the tooltip is redundant and goes.
                -->
                <div class="d-flex flex-column gap-2 mt-3">
                  @if (data.attendance && data.attendance.status !== "CLOSED") {
                    <button
                      class="btn btn-sm btn-outline-primary rounded-pill w-100 d-inline-flex align-items-center justify-content-center gap-1"
                      (click)="navigateToAttendance(data)"
                    >
                      <i class="ri-arrow-right-line"></i>
                      {{ "kanban.cardDetails.goToAttendance" | translate }}
                    </button>
                  } @else if (leadContact) {
                    <button
                      class="btn btn-sm btn-primary rounded-pill w-100 d-inline-flex align-items-center justify-content-center gap-1"
                      (click)="startNewChat(data)"
                    >
                      <i class="ri-customer-service-2-line"></i>
                      {{ "kanban.cardDetails.startAttendance" | translate }}
                    </button>
                  }
                  <!--
                    Default variant (`full`) — the labeled pill, matching the button
                    above instead of a lone circle beside it.

                    `callableContact`, not `contactDetail()`: the widget must not wait
                    for this dialog's HTTP fetch to offer the call, and it must reach the
                    customer's own number when the deal has no lead document — which is
                    the number printed two rows below. See the getter. The VoIP module
                    and the user's extension still gate it, inside the widget.
                  -->
                  <softphone-widget [contact]="callableContact" />
                </div>
              </div>

              <div class="mb-1">
                <div
                  class="text-uppercase text-muted mb-2"
                  style="font-size: calc(var(--ct-small-font-size) - 1.6px); letter-spacing: 0.5px"
                >
                  {{ "kanban.cardDetails.contact" | translate }}
                </div>

                <div
                  class="d-flex align-items-start gap-2 mb-2"
                  style="font-size: calc(var(--ct-small-font-size) + 0.8px)"
                >
                  <i class="uil uil-phone text-muted" style="width: 14px"></i>
                  <span>{{ data?.customer?.phone ?? "-" }}</span>
                </div>

                <!--
                  Tags of the deal — read from and written to the LEAD (Customer), never
                  the contact (owner decision 2026-08-21). A lead can hold more than one
                  contact, so a tag on one of its phone numbers is not representative of
                  the deal.

                  Arranged the way the attendance report already arranges them
                  (`report-attendance-list.v2.component.html`): the first three inline,
                  the rest behind a `+N`.

                  Three reasons this row is not a plain wrap of every tag. A lead with
                  eight tags pushed the phone, the e-mail and the whole contact block
                  down the sidebar, and this is a 200px column. A long title had nowhere
                  to go, so it wrapped mid-word — hence the same `truncate: 15` with the
                  full title on the tooltip. And `fontColor` was never applied, so a tag
                  configured with a dark background rendered dark-on-dark: the tenant
                  picks BOTH colours and only one of them was being honoured.

                  `mat-menu` rather than a Bootstrap dropdown, deliberately and for the
                  same reason the outcome picker in this dialog is a dialog: a dropdown
                  here is clipped by `.modal-body`'s own overflow, and Popper cannot
                  escape it. The CDK overlay renders at body level and cannot be
                  clipped. That is also why the add control is a menu and not the
                  attendance panel's `mat-select`, which has no room in this column.
                -->
                <!--
                  No "deal without a lead" branch here on purpose: this whole sidebar
                  already lives inside `@if (data.customer)`, so a deal with no lead
                  renders none of it — including this row. A hint would be dead markup.
                -->
                <div class="d-flex align-items-start gap-2 mb-2">
                  <i class="uil uil-tag-alt text-muted tag-row-icon"></i>

                  <div class="d-flex flex-wrap gap-1">
                    @for (tag of leadTags() | slice: 0 : 3; track tag._id) {
                      <span
                        class="badge font-12 text-capitalize d-inline-flex align-items-center gap-1"
                        [class.bg-secondary]="!tag.bgColor"
                        [ngStyle]="{
                          'background-color': tag.bgColor || null,
                          color: (tag.bgColor | readableText: tag.fontColor),
                        }"
                        [matTooltip]="tag.title"
                      >
                        {{ tag.title | truncate: 15 }}
                        <!--
                          Removal is the same single toggle the attendance panel calls,
                          on the badge itself. `uil` to match this sidebar's icon set
                          rather than the `ri-delete-bin-5-line` the attendance panel
                          uses; the affordance and the call are identical.
                        -->
                        <i
                          class="uil uil-times cursor-pointer"
                          [matTooltip]="
                            'kanban.cardDetails.removeTag' | translate
                          "
                          (click)="addRemoveTag(tag); $event.stopPropagation()"
                        ></i>
                      </span>
                    }

                    @if (leadTags().length > 3) {
                      <span
                        class="badge bg-light text-dark font-12 cursor-pointer"
                        [matMenuTriggerFor]="allLeadTagsMenu"
                        (click)="$event.stopPropagation()"
                        [matTooltip]="
                          'kanban.cardDetails.viewMoreTags' | translate
                        "
                      >
                        +{{ leadTags().length - 3 }}
                      </span>
                      <mat-menu
                        #allLeadTagsMenu="matMenu"
                        class="custom-menu-panel"
                      >
                        <div
                          class="d-flex flex-column gap-1 p-2"
                          (click)="$event.stopPropagation()"
                        >
                          @for (tag of leadTags() | slice: 3; track tag._id) {
                            <span
                              class="badge font-12 text-capitalize d-inline-flex align-items-center justify-content-between gap-2"
                              [class.bg-secondary]="!tag.bgColor"
                              [ngStyle]="{
                                'background-color': tag.bgColor || null,
                                color: (tag.bgColor | readableText: tag.fontColor),
                              }"
                            >
                              {{ tag.title }}
                              <i
                                class="uil uil-times cursor-pointer"
                                [matTooltip]="
                                  'kanban.cardDetails.removeTag' | translate
                                "
                                (click)="
                                  addRemoveTag(tag); $event.stopPropagation()
                                "
                              ></i>
                            </span>
                          }
                        </div>
                      </mat-menu>
                    }

                    <span
                      class="badge bg-soft-primary text-primary font-12 cursor-pointer d-inline-flex align-items-center gap-1"
                      [matMenuTriggerFor]="addLeadTagMenu"
                      (click)="$event.stopPropagation()"
                    >
                      <i class="uil uil-plus"></i>
                      {{ "kanban.cardDetails.addTag" | translate }}
                    </span>
                    <mat-menu
                      #addLeadTagMenu="matMenu"
                      class="custom-menu-panel"
                      (closed)="resetTagSearch()"
                    >
                      <!--
                        Same searchable-menu shape the contacts list already uses for its
                        tag filter (`contact-list.v2.component.html`): the field inside
                        the panel, `input-trend-search` for the magnifier, and the click
                        swallowed so typing does not dismiss the menu.

                        `keydown` needs the handler the contacts list does not: there the
                        options are plain divs, here they are `mat-menu-item`, and
                        `MatMenu` builds its key manager `withTypeAhead()` — a letter
                        reaching the panel would jump focus to a matching item on the very
                        first keystroke and leave the field empty.

                        The panel's own size comes from this content — see `.tag-picker`
                        in the stylesheet for why it is constrained here.
                      -->
                      <div
                        class="tag-picker"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="input-trend-search p-2">
                          <!--
                            Plain `form-control` and `mt-2`, matching the contacts list
                            exactly: `.search-icon` is absolutely positioned at `top: 0`
                            with a 40px box, so the offset has to equal the wrapper's
                            `p-2` and the field's height has to stay near 40px — a
                            `form-control-sm` would leave the magnifier off-centre.
                          -->
                          <input
                            type="text"
                            class="form-control"
                            [formControl]="tagSearchControl"
                            (click)="$event.stopPropagation()"
                            (keydown)="onTagSearchKeydown($event)"
                            [placeholder]="
                              'kanban.cardDetails.searchTagPlaceholder'
                                | translate
                            "
                          />
                          <span class="mdi mdi-magnify search-icon mt-2"></span>
                        </div>

                        @if (selectableTags.length === 0) {
                          <div class="px-3 pb-2 text-muted font-12">
                            {{
                              (tagSearch()
                                ? "kanban.cardDetails.noTagsFound"
                                : "kanban.cardDetails.noTagsAvailable"
                              ) | translate
                            }}
                          </div>
                        } @else {
                          <div class="tag-picker-list">
                            @for (tag of selectableTags; track tag._id) {
                              <button
                                mat-menu-item
                                type="button"
                                (click)="addRemoveTag(tag)"
                              >
                                <span
                                  class="badge font-12 text-capitalize"
                                  [class.bg-secondary]="!tag.bgColor"
                                  [ngStyle]="{
                                    'background-color': tag.bgColor || null,
                                    color: (tag.bgColor | readableText: tag.fontColor),
                                  }"
                                >
                                  {{ tag.title }}
                                </span>
                              </button>
                            }
                          </div>
                        }
                      </div>
                    </mat-menu>
                  </div>
                </div>

                <div
                  class="d-flex align-items-start gap-2 mb-2"
                  style="font-size: calc(var(--ct-small-font-size) + 0.8px)"
                >
                  <i class="uil uil-at text-muted" style="width: 14px"></i>
                  <span class="text-truncate" style="max-width: 160px">
                    {{ data?.customer.email || "-" }}
                  </span>
                </div>

                <!--
                  E2 — the account's company block and origin, read-only. Editing goes
                  through the lead modal (spec A-10), opened by the button below.
                -->
                @if (hasCompanyBlock) {
                  <div
                    class="text-uppercase text-muted mt-3 mb-1 section-caption"
                  >
                    {{ "kanban.cardDetails.companyBlock" | translate }}
                  </div>
                  <div class="section-body">
                    <div class="fw-bold">
                      {{
                        data?.customer?.tradeName ||
                          data?.customer?.legalName ||
                          "-"
                      }}
                    </div>
                    @if (data?.customer?.tin) {
                      <div class="text-muted">
                        {{ documentLabel }} {{ data?.customer?.tin }}
                      </div>
                    }
                    @if (companySummary) {
                      <div class="text-muted">{{ companySummary }}</div>
                    }
                  </div>
                }

                <button
                  type="button"
                  class="btn btn-sm btn-soft-primary mt-3 w-100"
                  (click)="openEditLead()"
                >
                  <i class="ri-edit-line me-1"></i
                  >{{ "kanban.cardDetails.editLead" | translate }}
                </button>
              </div>
            </div>

            <div class="d-flex flex-column">
              @if (data?.budget) {
                <div class="border-top pt-3">
                  <div
                    class="text-uppercase text-muted mb-1"
                    style="font-size: calc(var(--ct-small-font-size) - 1.6px); letter-spacing: 0.5px"
                  >
                    {{ "kanban.cardDetails.estimatedValue" | translate }}
                  </div>
                  <div class="fw-bold" style="font-size: 1rem">
                    {{ data.budget | currency: "BRL" : "symbol" : "1.2-2" }}
                  </div>
                </div>
              }
              <hr />

              <div class="custom-switch mt-2">
                <input
                  type="checkbox"
                  id="privacy"
                  [checked]="data.isPrivate"
                  (change)="updatePrivacy($any($event.target).checked)"
                  data-switch="danger"
                />
                <label for="privacy">
                  <span class="text-muted">
                    {{ "kanban.cardDetails.opportunity" | translate }}

                    {{ data.isPrivate ? "Privada" : "Publica" }}
                  </span>
                </label>
              </div>
            </div>
          } @else {
            <div class="d-flex align-items-center justify-content-center h-100">
              <div class="text-center px-3">
                <div
                  class="rounded-circle bg-light border d-inline-flex align-items-center justify-content-center mb-3"
                  style="width: 56px; height: 56px"
                >
                  <i
                    class="mdi mdi-account-off-outline text-secondary"
                    style="font-size: 24px"
                  ></i>
                </div>

                <p class="fw-medium text-dark mb-1 small">
                  {{ "kanban.cardDetails.noRelatedContact" | translate }}
                </p>
              </div>
            </div>
          }
        </div>

        <div class="details-section d-flex flex-column col-10 gap-2">
          <div class="">
            <div class="mt-2">
              <div style="width: 98%">
                <div
                  class="d-flex justify-content-between align-items-center mb-2"
                >
                  <span class="text-muted fw-semibold text-uppercase">
                    <i class="mdi mdi-text me-1"></i>
                    {{ "kanban.cardDetails.description" | translate }}
                  </span>
                </div>

                @if (editingDescription) {
                  <textarea
                    class="form-control form-control-sm rounded-2 shadow-none"
                    rows="4"
                    [(ngModel)]="descriptionDraft"
                    (keydown.escape)="cancelDescription()"
                    style="resize: vertical; transition: box-shadow 0.2s ease"
                  ></textarea>
                } @else {
                  <div
                    class="p-3 rounded-2 text-dark hover-bg-light"
                    role="button"
                    [title]="'kanban.cardDetails.clickToEditTitle' | translate"
                    (click)="startEditDescription()"
                  >
                    <p
                      class="mb-0 small lh-base"
                      style="word-break: break-word; white-space: pre-line"
                    >
                      {{ data?.description || "Sem descrição." }}
                    </p>
                  </div>
                }
              </div>

              @if (editingDescription) {
                <div class="d-flex gap-2 mt-2">
                  <button
                    class="btn btn-sm btn-primary px-3"
                    (click)="saveDescription()"
                    [disabled]="loadingContent"
                  >
                    @if (loadingContent) {
                      <i class="mdi mdi-spin mdi-loading"></i>
                    } @else {
                      <i class="mdi mdi-check"></i>
                    }
                  </button>
                  <button
                    class="btn btn-sm btn-outline-secondary px-3"
                    (click)="cancelDescription()"
                  >
                    <i class="mdi mdi-close"></i>
                  </button>
                </div>
              }
            </div>

            <hr style="width: 98%" />

            <div class="row mb-3 g-3 d-flex align-items-center">
              <div class="col-12 col-md-4">
                <div class="py-2 px-3 rounded-2 bg-light bg-opacity-25">
                  <small
                    class="text-muted d-block mb-1 fw-semibold text-uppercase"
                  >
                    <i class="bi bi-calendar-plus me-1"></i>
                    {{ "kanban.cardDetails.creationDate" | translate }}
                  </small>
                  <p class="mb-0 fw-semibold small">
                    {{
                      $safeNavigationMigration(data?.createdAt)
                        | date: "dd/MM/yyyy 'às' HH:mm:ss" : "pt-BR"
                    }}
                  </p>
                </div>
              </div>

              @if (
                data?.won === true || data?.won === false || data?.closedAt
              ) {
                <div class="col-12 col-md-4">
                  <div class="py-2 px-3 rounded-2 bg-light bg-opacity-50">
                    <small
                      class="text-muted d-block mb-1 fw-semibold text-uppercase"
                    >
                      <i
                        class="mdi me-1"
                        [ngClass]="{
                          'mdi-check-circle-outline text-success':
                            data?.won === true,
                          'mdi-close-circle-outline text-danger':
                            data?.won === false,
                          'mdi-lock-outline text-secondary': $safeNavigationMigration(data?.won) === null,
                        }"
                      ></i>
                      {{
                        data?.won === true
                          ? "Data de ganho"
                          : data?.won === false
                            ? "Data de perda"
                            : "Data de fechamento"
                      }}
                    </small>
                    <p
                      class="mb-0 fw-semibold small"
                      [ngClass]="{
                        'text-success': data?.won === true,
                        'text-danger': data?.won === false,
                      }"
                    >
                      {{
                        data?.won === true
                          ? (data.winDate
                            | date: "dd/MM/yyyy 'às' HH:mm:ss" : "pt-BR")
                          : data?.won === false
                            ? (data.lostDate
                              | date: "dd/MM/yyyy 'às' HH:mm:ss" : "pt-BR")
                            : (data.closedAt
                              | date: "dd/MM/yyyy 'às' HH:mm:ss" : "pt-BR")
                      }}
                    </p>
                  </div>
                </div>
              }

              @if (
                data?.won === false && (data?.lossReason || data?.lossReasonKey)
              ) {
                <!-- E3 RF-27: why the deal was lost — a company reason by name, or the platform discard with its note. -->
                <div class="col-12 col-md-4">
                  <div class="py-2 px-3 rounded-2 bg-light bg-opacity-50">
                    <small
                      class="text-muted d-block mb-1 fw-semibold text-uppercase"
                    >
                      <i class="mdi mdi-close-circle-outline me-1 text-danger"></i>
                      {{ "kanban.cardDetails.lossReason" | translate }}
                    </small>
                    <p class="mb-0 fw-semibold small">
                      {{ lossReasonLabel }}
                      @if (data?.lossReasonKey) {
                        <span class="badge bg-soft-secondary text-muted ms-1 font-11">
                          {{ "kanban.lossReason.platformBadge" | translate }}
                        </span>
                      }
                    </p>
                    @if (data?.lossNote) {
                      <p class="mb-0 small text-muted">{{ data.lossNote }}</p>
                    }
                  </div>
                </div>
              }

              <div class="col-12 col-md-4">
                <div class="py-2 px-3 rounded-2">
                  <small
                    class="text-muted d-block mb-1 fw-semibold text-uppercase"
                    style="font-size: calc(var(--ct-small-font-size) - 0.8px); letter-spacing: 0.04em"
                  >
                    {{ "kanban.cardDetails.responsible" | translate }}
                  </small>
                  <div class="dropdown">
                    <div
                      class="d-flex align-items-center gap-2 px-2 py-1 rounded-2 lement-hover"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      style="transition: background-color 0.2s ease"
                    >
                      <img
                        [src]="getUserImage(data.user)"
                        class="rounded-circle border flex-shrink-0"
                        width="32"
                        height="32"
                        (error)="onImageError($event)"
                      />
                      <span class="fw-semibold small text-truncate flex-grow-1">
                        {{ data.user?.name ?? "Sem responsável" }}
                      </span>
                      <i
                        class="mdi mdi-chevron-down text-muted"
                        style="font-size: calc(var(--ct-small-font-size) + 1.6px)"
                      ></i>
                    </div>

                    <div
                      class="dropdown-menu shadow-sm border-light-subtle p-1"
                      style="
                        min-width: 220px;
                        max-height: 240px;
                        overflow-y: auto;
                      "
                    >
                      <div
                        class="dropdown-item rounded-2 d-flex align-items-center gap-2 py-2"
                        role="button"
                        (click)="updateResponsible(null)"
                      >
                        <div
                          class="rounded-circle bg-secondary bg-opacity-10 d-flex align-items-center justify-content-center flex-shrink-0"
                          style="width: 30px; height: 30px"
                        >
                          <i
                            class="mdi mdi-account-off-outline text-secondary"
                            style="font-size: var(--ct-body-font-size)"
                          ></i>
                        </div>
                        <span class="text-muted small">{{
                          "kanban.cardDetails.noResponsible" | translate
                        }}</span>
                      </div>
                      <div class="dropdown-divider my-0"></div>
                      @for (user of users; track user._id) {
                        <div
                          class="dropdown-item rounded-2 d-flex align-items-center gap-2 py-2"
                          role="button"
                          (click)="updateResponsible(user)"
                        >
                          <img
                            [src]="getUserImage(user)"
                            (error)="onImageError($event)"
                            class="rounded-circle border flex-shrink-0"
                            width="30"
                            height="30"
                            style="object-fit: cover"
                          />
                          <span class="small text-truncate">{{
                            user.name
                          }}</span>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex flex-column gap-2 mt-4">
            <ul class="nav nav-tabs nav-bordered" role="tablist">
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link active"
                  id="comments-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#comments"
                  type="button"
                  role="tab"
                  aria-controls="comments"
                  aria-selected="true"
                >
                  <i
                    class="mdi mdi-comment-text-outline download-icon d-md-none d-block"
                  ></i>
                  <span class="d-none d-md-inline">
                    {{ "kanban.cardDetails.tabComments" | translate }}
                    @if (organizedComments()?.length > 0) {
                      <small
                        class="badge bg-primary bg-opacity-75 text-white font-12 ms-1 fw-bold"
                      >
                        {{ organizedComments()?.length }}
                      </small>
                    }
                  </span>
                </a>
              </li>
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link"
                  id="infos-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#infos"
                  type="button"
                  role="tab"
                  aria-controls="infos"
                  aria-selected="true"
                >
                  <i
                    class="mdi mdi-cube-outline download-icon d-md-none d-block"
                  ></i>
                  <span class="d-none d-md-inline">{{
                    "kanban.cardDetails.tabProductsAndValues" | translate
                  }}</span>
                </a>
              </li>
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link"
                  id="history-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#history"
                  type="button"
                  role="tab"
                  aria-controls="history"
                  aria-selected="false"
                >
                  <i class="mdi mdi-history d-md-none d-block"></i>
                  <span class="d-none d-md-inline">{{
                    "kanban.cardDetails.tabHistory" | translate
                  }}</span>
                </a>
              </li>

              <!--
                Activities tab (SPEC-2026-08-crm-pipeline-deals-radar — RF-38, RF-40).

                `GET /api/task/card/:idCard` was built with the activity endpoints and had
                no consumer until this tab existed: the deal's interaction log had nowhere
                to be read. Placed after History because it is the actionable twin of it —
                History says what happened to the deal, this says what was done about it.
              -->
              <li class="nav-item" role="presentation">
                <a
                  href="#activities"
                  data-bs-toggle="tab"
                  id="activities-tab"
                  role="tab"
                  class="nav-link"
                  aria-controls="activities"
                  aria-selected="false"
                >
                  <span class="d-block d-sm-none"
                    ><i class="ri-checkbox-circle-line"></i
                  ></span>
                  <span class="d-none d-sm-block">
                    {{ "kanban.cardDetails.tabActivities" | translate }}
                    @if (activities.length > 0) {
                      <span class="badge bg-soft-primary text-primary ms-1">{{
                        activities.length
                      }}</span>
                    }
                  </span>
                </a>
              </li>
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link"
                  id="files-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#files"
                  type="button"
                  role="tab"
                  aria-controls="files"
                  aria-selected="false"
                >
                  <i class="mdi mdi-file d-md-none d-block"></i>
                  <span class="d-none d-md-inline">{{
                    "kanban.cardDetails.tabFiles" | translate
                  }}</span>
                </a>
              </li>
            </ul>

            <div class="tab-content scroll me-2 px-2" style="height: 380px">
              <!-- Comment  -->
              <div
                class="tab-pane fade show active"
                id="comments"
                role="tabpanel"
                aria-labelledby="comments-tab"
              >
                <div class="mt-lg-0 rounded">
                  <div class="">
                    <div class="border rounded mb-3">
                      <form [formGroup]="formGroup" class="mb-0 px-1">
                        <textarea
                          rows="2"
                          class="form-control border-0 resize-none"
                          [placeholder]="
                            'kanban.cardDetails.commentPlaceholder' | translate
                          "
                          formControlName="comment"
                          (keydown)="handleKeydown($event)"
                        ></textarea>
                        <div
                          class="p-1 d-flex align-items-center"
                          [ngClass]="{
                            'justify-content-between':
                              replyingTo() || editingComment(),
                            'justify-content-end':
                              !replyingTo() && !editingComment(),
                          }"
                        >
                          @if (replyingTo() || editingComment()) {
                            <div>
                              <a
                                href="javascript:void(0);"
                                class="badge bg-info bg-opacity-75 px-1 d-inline-flex align-items-center"
                                (click)="
                                  replyingTo() ? cancelReply() : cancelEdit()
                                "
                              >
                                {{
                                  replyingTo()
                                    ? "Cancelar resposta"
                                    : "Cancelar edição"
                                }}
                                <i class="mdi mdi-close ms-1"></i>
                              </a>
                            </div>
                          }
                          <button
                            type="button"
                            class="btn btn-sm btn-success float-end"
                            (click)="saveComment()"
                            [disabled]="
                              !formGroup.valid ||
                              loadingContent ||
                              !formGroup.get('comment')?.value?.trim()
                            "
                          >
                            @if (loadingContent) {
                              <i class="mdi mdi-spin mdi-loading me-1"></i>
                            } @else {
                              <i class="uil uil-message"></i>
                            }
                          </button>
                        </div>
                      </form>
                    </div>

                    @for (comment of organizedComments(); track comment._id) {
                      <div class="d-flex mb-3">
                        <img
                          [src]="getUserImage($safeNavigationMigration(comment?.author))"
                          (error)="onImageError($event)"
                          alt="avatar"
                          class="img-thumbnail avatar-small rounded-circle me-1"
                        />
                        <div class="w-100">
                          <div class="mt-0">
                            <span
                              class="fw-bold text-dark text-truncate font-16"
                            >
                              {{
                                comment?.author?.name ?? "Usuário Desconhecido"
                              }}
                            </span>
                            <small class="text-muted ms-2">
                              {{ getTimeAgo($safeNavigationMigration(comment?.createdAt)) }}
                            </small>
                            <div class="dropdown float-end">
                              <a
                                href="javascript:void(0);"
                                class="dropdown-toggle text-muted arrow-none"
                                data-bs-toggle="dropdown"
                                aria-expanded="true"
                              >
                                <i class="mdi mdi-dots-vertical font-18"></i>
                              </a>
                              <div
                                class="dropdown-menu dropdown-menu-end"
                                data-popper-placement="bottom-end"
                                style="
                                  position: absolute;
                                  inset: 0px 0px auto auto;
                                  margin: 0px;
                                  transform: translate(0px, 27px);
                                "
                              >
                                <a
                                  href="javascript:void(0);"
                                  class="dropdown-item"
                                  (click)="editComment(comment)"
                                >
                                  <i class="mdi mdi-pencil me-1"></i
                                  >{{ "kanban.cardDetails.edit" | translate }}
                                </a>
                                <a
                                  href="javascript:void(0);"
                                  class="dropdown-item"
                                  (click)="deleteComment(comment)"
                                >
                                  <i class="mdi mdi-delete me-1"></i
                                  >{{ "kanban.cardDetails.remove" | translate }}
                                </a>
                              </div>
                            </div>
                          </div>
                          <p class="mb-1 font-12 fw-semibold text-dark">
                            {{ comment?.content }}
                          </p>

                          <a
                            href="javascript:void(0);"
                            class="text-muted font-12 d-inline-block ms-3"
                            (click)="reply(comment)"
                          >
                            <i
                              class="mdi mdi-reply fs-4"
                              [matTooltip]="
                                'kanban.cardDetails.replyTooltip' | translate
                              "
                            ></i>
                            @if (
                              comment.replies && comment.replies.length > 0
                            ) {
                              <span class="badge bg-secondary ms-1">
                                {{ comment.replies.length }}
                              </span>
                            }
                          </a>

                          @if (comment.replies && comment.replies.length > 0) {
                            @for (
                              replyItem of comment.replies;
                              track replyItem._id
                            ) {
                              <div
                                class="d-flex mt-2 ms-4 border-start border-2 ps-3"
                              >
                                <img
                                  [src]="getUserImage($safeNavigationMigration(replyItem?.author))"
                                  (error)="onImageError($event)"
                                  alt="avatar"
                                  class="img-thumbnail avatar-small rounded-circle me-1"
                                />
                                <div class="w-100">
                                  <div class="mt-0">
                                    <span
                                      class="fw-bold text-dark text-truncate font-16"
                                    >
                                      {{
                                        replyItem?.author?.name ??
                                          "Usuário Desconhecido"
                                      }}
                                    </span>
                                    <small class="text-muted ms-2">
                                      {{ getTimeAgo($safeNavigationMigration(replyItem?.createdAt)) }}
                                    </small>
                                    <div class="dropdown float-end">
                                      <a
                                        href="javascript:void(0);"
                                        class="dropdown-toggle text-muted arrow-none"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="true"
                                      >
                                        <i
                                          class="mdi mdi-dots-vertical font-18"
                                        ></i>
                                      </a>
                                      <div
                                        class="dropdown-menu dropdown-menu-end"
                                        data-popper-placement="bottom-end"
                                        style="
                                          position: absolute;
                                          inset: 0px 0px auto auto;
                                          margin: 0px;
                                          transform: translate(0px, 27px);
                                        "
                                      >
                                        <a
                                          href="javascript:void(0);"
                                          class="dropdown-item"
                                          (click)="editComment(replyItem)"
                                        >
                                          <i class="mdi mdi-pencil me-1"></i
                                          >{{
                                            "kanban.cardDetails.edit"
                                              | translate
                                          }}
                                        </a>
                                        <a
                                          href="javascript:void(0);"
                                          class="dropdown-item"
                                          (click)="deleteComment(replyItem)"
                                        >
                                          <i class="mdi mdi-delete me-1"></i
                                          >{{
                                            "kanban.cardDetails.remove"
                                              | translate
                                          }}
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                  <p class="mb-0 font-12 fw-semibold text-dark">
                                    {{ replyItem?.content }}
                                  </p>

                                  <a
                                    href="javascript:void(0);"
                                    class="text-muted font-12 d-inline-block ms-3"
                                    (click)="reply(comment)"
                                  >
                                    <i
                                      class="mdi mdi-reply fs-4"
                                      [matTooltip]="
                                        'kanban.cardDetails.replyTooltip'
                                          | translate
                                      "
                                    ></i>
                                  </a>
                                </div>
                              </div>
                            }
                          }
                        </div>
                      </div>
                    }

                    @if (organizedComments().length > comments.perPage) {
                      <div class="text-center mt-2">
                        <a
                          href="javascript:void(0);"
                          class="text-danger"
                          (click)="loadPage(comments.page + 1)"
                        >
                          @if (loadingContent) {
                            <i class="mdi mdi-spin mdi-loading me-1"></i>
                          } @else {
                            {{ "kanban.cardDetails.loadMore" | translate }}
                          }
                        </a>
                      </div>
                    }
                  </div>
                </div>
              </div>

              <!-- Infos -->
              <div
                class="tab-pane fade"
                id="infos"
                role="tabpanel"
                aria-labelledby="infos-tab"
              >
                <div class="p-2 mt-lg-0 rounded">
                  <div class="row">
                    <div class="col-lg-8 border rounded m-0 p-0">
                      <div
                        class="p-2 d-flex align-items-center justify-content-between"
                      >
                        <span class="text-muted fw-semibold text-uppercase">
                          <i class="mdi mdi-package-variant me-1"></i>
                          {{ "kanban.cardDetails.products" | translate }}
                        </span>
                        @if (!editingProducts) {
                          <button
                            class="btn btn-sm btn-soft-primary"
                            (click)="startEditProducts()"
                          >
                            <i class="mdi mdi-pencil me-1"></i>
                            {{ "kanban.cardDetails.edit" | translate }}
                          </button>
                        }
                      </div>

                      @if (editingProducts) {
                        <div class="px-3 pb-2">
                          <mat-select
                            [formControl]="productSelectControl"
                            class="form-control"
                            multiple
                            [compareWith]="compareProduct"
                            [placeholder]="
                              'kanban.cardDetails.selectProductsPlaceholder'
                                | translate
                            "
                          >
                            <div
                              class="overflow-auto"
                              style="max-height: 220px"
                            >
                              <div class="col-12 input-trend-search p-1">
                                <input
                                  class="form-control"
                                  type="text"
                                  (click)="$event.stopPropagation()"
                                  [placeholder]="
                                    'kanban.cardDetails.searchProductPlaceholder'
                                      | translate
                                  "
                                  [formControl]="productControl"
                                />
                                <span
                                  class="mdi mdi-magnify search-icon mt-1"
                                ></span>
                              </div>
                              @if (listProduct.length === 0) {
                                <mat-option disabled>{{
                                  "kanban.cardDetails.noProductFound"
                                    | translate
                                }}</mat-option>
                              }
                              @for (item of listProduct; track item._id) {
                                <mat-option [value]="item">{{
                                  item.name
                                }}</mat-option>
                              }
                            </div>
                            @if (!isAttendant()) {
                              <div
                                class="d-flex justify-content-end p-1 border-top bg-white"
                              >
                                <button
                                  class="btn btn-outline-light"
                                  (click)="
                                    $event.stopPropagation();
                                    $event.preventDefault();
                                    createProduct()
                                  "
                                >
                                  <i class="mdi mdi-plus me-1"></i>
                                  <span>{{
                                    "kanban.cardDetails.newProduct" | translate
                                  }}</span>
                                </button>
                              </div>
                            }
                          </mat-select>

                          <div class="d-flex gap-2 mt-2 justify-content-end">
                            <button
                              class="btn btn-sm btn-primary px-3"
                              (click)="saveProducts()"
                              [disabled]="loadingContent"
                            >
                              <i class="mdi mdi-check me-1"></i>
                              {{ "kanban.cardDetails.save" | translate }}
                            </button>
                            <button
                              class="btn btn-sm btn-outline-secondary px-3"
                              (click)="cancelEditProducts()"
                            >
                              <i class="mdi mdi-close me-1"></i>
                              {{ "kanban.cardDetails.cancel" | translate }}
                            </button>
                          </div>
                        </div>
                      }
                      <div class="table-responsive">
                        <table
                          class="table table-borderless table-nowrap table-centered mb-0"
                        >
                          <thead class="bg-light bg-opacity-50 thead-sm">
                            <tr>
                              <th>
                                {{
                                  "kanban.cardDetails.tableProduct" | translate
                                }}
                              </th>
                              <th>
                                {{
                                  "kanban.cardDetails.tablePrice" | translate
                                }}
                              </th>
                              <th style="width: 50px"></th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (product of data?.product; track $index) {
                              <tr>
                                <td>
                                  <p
                                    class="m-0 d-inline-block align-middle font-16"
                                  >
                                    <a
                                      href="apps-ecommerce-products-details.html"
                                      class="text-body"
                                    >
                                      {{ product.name ?? "-" }}
                                    </a>
                                  </p>
                                </td>
                                <td>
                                  {{
                                    (product.price
                                      | currency: "BRL" : "symbol" : "1.2-2") ??
                                      "R$ 0,00"
                                  }}
                                </td>
                                <td>
                                  <a
                                    href="javascript:void(0);"
                                    class="action-icon"
                                    (click)="removeProduct(product)"
                                  >
                                    <i class="mdi mdi-delete text-danger"></i>
                                  </a>
                                </td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div class="col-lg-4">
                      <div class="border p-3 mt-lg-0 rounded">
                        <div class="table-responsive">
                          <table class="table mb-0">
                            <tbody>
                              <tr>
                                <td>
                                  {{
                                    "kanban.cardDetails.valueLabel" | translate
                                  }}
                                </td>
                                <td>
                                  {{
                                    (data.budget
                                      | currency: "BRL" : "symbol" : "1.2-2") ??
                                      "R$ 0,00"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <th>
                                  {{
                                    "kanban.cardDetails.totalLabel" | translate
                                  }}
                                </th>
                                <th>
                                  {{
                                    (data.budget
                                      | currency: "BRL" : "symbol" : "1.2-2") ??
                                      "R$ 0,00"
                                  }}
                                </th>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Timeline -->
              <div
                class="tab-pane fade"
                id="history"
                role="tabpanel"
                aria-labelledby="history-tab"
              >
                @if (loadingContent) {
                  <loading-component />
                }

                @if (!loadingContent && timelineData().length > 0) {
                  <div class="mt-2 timeline-alt py-0">
                    <div class="timeline-show text-center">
                      <h5 class="m-0 time-show-name">
                        {{ "kanban.cardDetails.lastUpdate" | translate }}
                        {{
                          $safeNavigationMigration(timelineData()[0]?.updatedAt)
                            | timezoneDate
                              : "DD/MM/YYYY - HH:mm"
                              : getTimezoneCompanyCurrentUser()
                        }}
                      </h5>
                    </div>
                    @for (item of timelineData(); track $index) {
                      <div class="timeline-item">
                        <i
                          class="mdi mdi-clock-time-nine-outline bg-primary-lighten text-primary timeline-icon font-24 me-3 custom-icon"
                          [ngClass]="{
                            'mdi-trophy bg-success-lighten text-success':
                              item?.entityObj?.['won'] === true,
                            'mdi-close-circle bg-danger-lighten text-danger':
                              item?.entityObj?.['won'] === false,
                            'mdi-file-document bg-primary-lighten text-primary':
                              isCreateEntry(item),
                            'mdi-swap-horizontal bg-info-lighten text-info':
                              !item?.entityObj?.['won'] && isStageEntry(item),
                          }"
                        ></i>
                        <div
                          class="timeline-item-info d-flex flex-column align-items-start"
                        >
                          <a
                            href="javascript:void(0);"
                            class="fw-bold mb-1 d-block"
                            [ngClass]="{
                              'text-success': item?.entityObj?.['won'] === true,
                              'text-danger': item?.entityObj?.['won'] === false,
                              'text-primary': isCreateEntry(item),
                              'text-info':
                                !item?.entityObj?.['won'] && isStageEntry(item),
                            }"
                          >
                            {{ item?.name }}
                          </a>
                          <small>
                            {{ item?.description || "Sem descrição adicional" }}
                          </small>
                          <p class="mb-0 pb-2">
                            <small class="text-muted">
                              {{
                                $safeNavigationMigration(item?.updatedAt)
                                  | timezoneDate
                                    : "DD/MM/YYYY HH:mm"
                                    : getTimezoneCompanyCurrentUser()
                              }}
                            </small>
                          </p>
                        </div>
                      </div>
                    }
                  </div>
                }

                @if (!loadingContent && timelineData().length === 0) {
                  <div class="text-center py-5">
                    <i
                      class="mdi mdi-history text-muted"
                      style="font-size: 48px"
                    ></i>
                    <p class="text-muted mt-2">
                      {{ "kanban.cardDetails.noHistoryFound" | translate }}
                    </p>
                  </div>
                }
              </div>

              <!-- Files  -->
              <!--
                Activities pane (RF-38, RF-40). Hyper table + dropdown; the outcome list
                comes from the same enum the backend validates, and each label is an i18n
                key resolved at the render site.
              -->
              <div
                class="tab-pane fade"
                id="activities"
                role="tabpanel"
                aria-labelledby="activities-tab"
              >
                <!--
                  No horizontal padding here: `.tab-content` already carries `px-2`, and
                  the sibling panes (history, files) go straight to content. Adding `p-3`
                  inset this pane relative to the others and narrowed the 5-column table
                  enough to trigger a horizontal scrollbar.
                -->
                <div class="pt-2">
                  <div
                    class="d-flex justify-content-between align-items-center mb-3"
                  >
                    <div>
                      <h5 class="mb-1">
                        {{ "kanban.cardDetails.activitiesTitle" | translate }}
                      </h5>
                      <p class="text-muted font-13 mb-0">
                        {{
                          "kanban.cardDetails.activitiesSubtitle" | translate
                        }}
                      </p>
                    </div>
                    <button
                      class="btn btn-sm btn-primary"
                      (click)="openNextActionDialog()"
                    >
                      <i class="ri-add-line me-1"></i>
                      {{ "kanban.cardDetails.scheduleNextAction" | translate }}
                    </button>
                  </div>

                  @if (loadingActivities) {
                    <div class="text-center py-4">
                      <div
                        class="spinner-border spinner-border-sm text-primary"
                        role="status"
                      >
                        <span class="visually-hidden">{{
                          "kanban.cardDetails.activitiesLoading" | translate
                        }}</span>
                      </div>
                    </div>
                  } @else if (activities.length === 0) {
                    <div class="alert alert-secondary mb-0" role="alert">
                      <i class="ri-information-line me-1"></i>
                      {{ "kanban.cardDetails.activitiesEmpty" | translate }}
                    </div>
                  } @else {
                    <div class="table-responsive">
                      <table class="table table-centered table-hover mb-0">
                        <thead class="table-light">
                          <tr>
                            <th>
                              {{
                                "kanban.cardDetails.activityType" | translate
                              }}
                            </th>
                            <th>
                              {{
                                "kanban.cardDetails.activityWhen" | translate
                              }}
                            </th>
                            <th>
                              {{
                                "kanban.cardDetails.activityOutcome" | translate
                              }}
                            </th>
                            <th>
                              {{
                                "kanban.cardDetails.activityOwner" | translate
                              }}
                            </th>
                            <th class="text-end"></th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (activity of activities; track activity._id) {
                            <tr>
                              <td>
                                <span class="fw-semibold">{{
                                  activityTypeLabel(activity) | translate
                                }}</span>
                                @if (activity.isNextAction) {
                                  <span
                                    class="badge bg-soft-primary text-primary ms-1"
                                  >
                                    {{
                                      "kanban.cardDetails.isNextAction"
                                        | translate
                                    }}
                                  </span>
                                }
                                @if (activity.name) {
                                  <br />
                                  <small class="text-muted">{{
                                    activity.name
                                  }}</small>
                                }
                              </td>
                              <td>
                                @if (activity.completedAt || activity.deadlineAt) {
                                  {{
                                    activity.completedAt ?? activity.deadlineAt
                                      | date: momentFormat(activity)
                                  }}
                                } @else {
                                  <!-- No date: the same mark as the tasks area, since no day view lists it. -->
                                  <span
                                    class="badge campaign-badge is-neutral"
                                    [matTooltip]="'task.activity.noDateHint' | translate"
                                    [attr.aria-label]="'task.activity.noDateHint' | translate"
                                  >
                                    <i class="ri-calendar-close-line me-1"></i>{{ "task.activity.noDate" | translate }}
                                  </span>
                                }
                                @if (activity.untimed && !activity.completedAt) {
                                  <br />
                                  <small class="text-muted">{{ "task.activity.untimed" | translate }}</small>
                                }
                                <!-- E4 RF-26: how many times it was postponed, and the moment it was first scheduled for. -->
                                @if (postponementCount(activity) > 0) {
                                  <br />
                                  <small class="text-muted">
                                    <i class="ri-history-line me-1"></i>
                                    {{ "task.activity.statePostponed" | translate: { count: postponementCount(activity) } }}
                                    @if (originalMoment(activity); as original) {
                                      · {{ "task.activity.originalMoment" | translate: { moment: (original | date: "d MMM y, HH:mm") } }}
                                    }
                                  </small>
                                }
                              </td>
                              <td>
                                @if (activity.concludedByWin) {
                                  <span class="badge campaign-badge is-neutral">{{ "task.activity.byWin" | translate }}</span>
                                } @else if (activity.outcome) {
                                  <span
                                    class="badge bg-soft-secondary text-muted"
                                    >{{
                                      activityOutcomeLabel(activity) | translate
                                    }}</span
                                  >
                                  <!-- E4 RF-09, RF-11: duration, notes and the deal's stage and health at the moment of conclusion. -->
                                  @if (activity.durationMinutes !== undefined && activity.durationMinutes !== null) {
                                    <small class="text-muted ms-1">{{ "task.activity.duration" | translate: { minutes: activity.durationMinutes } }}</small>
                                  }
                                  @if (activity.conclusionSnapshot?.stageName) {
                                    <br />
                                    <small class="text-muted">
                                      {{ "task.activity.snapshot" | translate: { stage: activity.conclusionSnapshot.stageName } }}
                                      @if (activity.conclusionSnapshot?.healthBand) {
                                        · {{ "task.activity.snapshotHealth" | translate: { health: ("kanban.healthBand." + activity.conclusionSnapshot.healthBand.toLowerCase() | translate) } }}
                                      }
                                    </small>
                                  }
                                  @if (activity.outcomeNote) {
                                    <br />
                                    <small class="text-muted"><i class="ri-sticky-note-line me-1"></i>{{ activity.outcomeNote }}</small>
                                  }
                                  @if (activity.nextStepSkipReason) {
                                    <br />
                                    <small class="text-muted"><i class="ri-skip-forward-line me-1"></i>{{ "task.activity.skipped" | translate: { reason: activity.nextStepSkipReason } }}</small>
                                  }
                                } @else {
                                  <span class="text-muted">—</span>
                                }
                              </td>
                              <td>{{ activity.user?.name ?? "—" }}</td>
                              <td class="text-end">
                                <!--
                                  E4 RF-17: Concluir opens the ONE conclusion dialog; Adiar the postpone
                                  dialog. A mat-menu renders in the CDK overlay, so — unlike the Bootstrap
                                  dropdown that used to be clipped here — it escapes the modal's stack.
                                -->
                                @if (!isConcluded(activity)) {
                                  <button
                                    class="btn btn-dropdown-list"
                                    type="button"
                                    [matMenuTriggerFor]="activityMenu"
                                    [attr.aria-label]="'task.activity.actions' | translate"
                                    (click)="$event.stopPropagation()"
                                  >
                                    <i class="ri-more-2-fill text-primary-emphasis"></i>
                                  </button>
                                  <mat-menu #activityMenu="matMenu">
                                    <button mat-menu-item type="button" (click)="openConclude(activity)">
                                      <i class="ri-checkbox-circle-line me-1"></i>
                                      {{ "task.activity.conclude" | translate }}
                                    </button>
                                    @if (canPostpone(activity)) {
                                      <button mat-menu-item type="button" (click)="openPostpone(activity)">
                                        <i class="ri-calendar-schedule-line me-1"></i>
                                        {{ "task.activity.postpone" | translate }}
                                      </button>
                                    }
                                  </mat-menu>
                                }
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  }
                </div>
              </div>

              <div
                class="tab-pane fade"
                id="files"
                role="tabpanel"
                aria-labelledby="files-tab"
              >
                <div class="row">
                  <div
                    class="upload-area h-40"
                    [ngStyle]="
                      (loadingSpinner$ | async) ? { filter: 'blur(1px)' } : {}
                    "
                    (click)="inputFile.click()"
                  >
                    @if (loadingSpinner$ | async) {
                      <loading-component class="loading" diameter="20" />
                    } @else {
                      <div class="placeholder-content">
                        <i
                          class="h2 text-muted mdi mdi-cloud-upload-outline text-primary"
                        ></i>
                        <h5>
                          {{ "kanban.cardDetails.clickToUpload" | translate }}
                        </h5>
                      </div>
                    }
                    <input
                      id="dropzone-file"
                      type="file"
                      class="d-none"
                      (multiple)="(true)"
                      #inputFile
                      (change)="onAttachmentsSelect($event)"
                    />
                  </div>
                  <div class="dropzone-previews mt-3" id="file-previews"></div>
                </div>
                @for (attachment of data?.attachments; track $index) {
                  <div class="card mb-1 shadow-none border">
                    <div class="p-2">
                      <div class="row align-items-center">
                        <div class="col-auto">
                          @if (isImage(attachment.filename)) {
                            <img
                              src="{{ attachment.url }}"
                              alt="{{ attachment.filename }}"
                              class="avatar-sm rounded"
                            />
                          } @else if (isPDF(attachment.filename)) {
                            <i class="h1 text-muted mdi mdi-file-pdf-box"></i>
                          } @else {
                            <i class="h1 text-muted mdi mdi-file-outline"></i>
                          }
                        </div>
                        <div class="col ps-0">
                          <a
                            href="javascript:void(0);"
                            class="text-muted fw-bold"
                          >
                            {{ attachment.filename }}
                          </a>
                          <p class="mb-0">
                            {{ formatBytes(attachment.size) }}
                          </p>
                        </div>
                        <div class="col-auto">
                          <a
                            href="javascript:void(0);"
                            class="btn btn-link btn-lg text-muted"
                            (click)="downloadFile(attachment)"
                            [matTooltip]="
                              'kanban.cardDetails.downloadTooltip' | translate
                            "
                          >
                            <i class="ri-download-2-line"></i>
                          </a>
                          <a
                            href="javascript:void(0);"
                            class="btn btn-link btn-lg text-danger"
                            (click)="removeAttachment(attachment)"
                            [matTooltip]="
                              'kanban.cardDetails.removeTooltip' | translate
                            "
                          >
                            <i class="ri-delete-bin-line"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
